import classnames from 'classnames';
import { type ReactNode, useEffect } from 'react';
import { UiKitContainer } from 'src/widgets/ui-kit-widget';
import { useAnalytics } from '@features/Analytics';
import type { TpUnsubscribeEventOptions } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import styles from './Container.module.scss';
export const Container = ({
  children,
  className,
  endContent,
  eventOnMounted,
  eventOptions,
  ...otherProps
}: {
  children: ReactNode;
  endContent?: ReactNode;
  className?: string;
  eventOnMounted?: string;
  eventOptions?: TpUnsubscribeEventOptions;
}) => {
  const {
    trackGoogleEvent
  } = useAnalytics();
  useEffect(() => {
    eventOnMounted && trackGoogleEvent({
      eventName: eventOnMounted,
      options: eventOptions
    });
  }, [eventOnMounted, eventOptions, trackGoogleEvent]);
  return <UiKitContainer className={classnames(styles.container, className)} {...otherProps} data-sentry-element="UiKitContainer" data-sentry-component="Container" data-sentry-source-file="index.tsx">
      {children}
      {endContent}
    </UiKitContainer>;
};